import React from 'react';
import { CtaButton } from './CtaButton';
import { FrameworkFlow } from './FrameworkFlow';
import { IMAGES } from '../data/coachSystem';
export function Hero() {
  return <header className="border-b border-navy-line bg-ivory" data-id="element-46" data-mp="9ktchjcqjuvn">
      <div className="mx-auto w-full max-w-[42rem] px-4 pb-9 pt-7 text-center sm:px-6 sm:pb-12 sm:pt-10 lg:max-w-3xl lg:pb-16 lg:pt-14" data-id="element-47" data-mp="9lbgx39jxfen">
        <p className="eyebrow text-[0.66rem] font-semibold text-teal sm:text-[0.72rem]" data-id="element-48" data-mp="129h2ttccdag2">
          Volleyball Coach System™
        </p>

        <h1 className="mt-4 font-display text-[2.05rem] font-medium leading-[1.1] tracking-tight text-navy sm:text-[2.75rem] lg:text-[3.15rem]" data-id="element-49" data-mp="xa4e131wttau">
          The Complete Coaching System for Volleyball Coaches
        </h1>

        <p className="mx-auto mt-3.5 max-w-[36rem] text-[0.98rem] leading-relaxed text-navy-muted sm:text-[1.05rem]" data-id="element-50" data-mp="nbopn7u9oy51">
          Save hours of planning, run better practices, and coach with
          confidence — without building every practice from scratch.
        </p>

        <img src={IMAGES.bundle} alt="The complete Volleyball Coach System™ bundle: six professional coaching volumes and five premium bonus guides shown as book covers beside the system box." className="mx-auto -mb-1 mt-4 w-full max-w-[27rem] sm:mt-6 sm:max-w-[30rem] lg:max-w-[33rem]" width={1400} height={1120} data-id="element-51" data-mp="3j895n7fl21mw" />

        <p className="mt-4 text-[0.7rem] font-bold uppercase tracking-[0.18em] text-navy" data-id="element-52" data-mp="30i15my76jrax">
          Volleyball Coach System™
        </p>

        <p className="mt-2 text-[0.98rem] font-semibold leading-snug text-navy sm:text-[1.05rem]" data-id="element-53" data-mp="359sxrd5zi536">
          6 Professional Coaching Volumes{' '}
          <span className="text-teal" aria-hidden="true" data-id="element-54" data-mp="2qi0lja1hl75o">
            +
          </span>{' '}
          5 Premium Bonuses
        </p>

        <FrameworkFlow className="mt-3.5" data-id="element-55" data-mp="2hix0i0irehoj" />

        <CtaButton label="Get instant access" size="lg" className="mt-6" data-id="element-56" data-mp="2hjymh01bcol1" />
        <p className="mt-2.5 text-[0.8rem] text-navy-muted" data-id="element-57" data-mp="2ljgz78izdtcs">
          Instant digital access • One-time payment
        </p>
      </div>
    </header>;
}